import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@akostm/orbit-ui';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ProgressionStateType } from '../../../interfaces';

@Component({
  selector: 'shared-status-icon',
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  templateUrl: './status-icon.component.html',
  styleUrl: './status-icon.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIconComponent {
  state = input.required<ProgressionStateType>();
  iconName = input.required<IconProp>();

  readonly ProgressionStateTypeEnum = ProgressionStateType;
}
